import React from 'react';
import { Provider } from 'react-redux';
import Tabs from '../multiTabs';
import { useFinanceData } from './financePage';
import { Box } from '@mui/material';
import SearchFilterContainer from '../../../containers/SearchFilterContainer';
import LicenceAnalyticsFiltersWrapper from '../filters/filtersWrapper';

const LicenseAnalyticsPage: React.FC = () => {
  useFinanceData();

  return (
    <Box className={'contentSpacing'}>
      {/* <Box className={'mb10'}>
        <SearchFilterContainer
          parent={"licenceAnalytics"}
        />
      </Box> */}
      <Box sx={{ width: '80%' }}>
        <LicenceAnalyticsFiltersWrapper />
      </Box>
      <div style={{ overflowY: 'auto', height: '110vh' }}>
        <Tabs />
      </div>
    </Box>
  );
};

export default LicenseAnalyticsPage;
